module.exports = __webpack_public_path__ + "static/media/galerija_2013 (13).4a5f34a2.jpg";